import { Pipe, PipeTransform } from '@angular/core';

/**
 * Sum a property of an array of objects.
 */
@Pipe({
  name: 'sum'
})
export class SumPipe implements PipeTransform {

  /**
   * Get the sum of an item's property in an array of objects.
   *
   * Can be used for displaying the totals of a column in a table.
   *
   * @param items Array of items (elements, area's, etc).
   * @param property The property to sum.
   * @returns The total of the item's values
   */
  transform<T>(items: T[], property: number): number {
    return items.reduce((sum, item) => sum + item[property], 0);
  }
}
